import * as React from "react";
const SvgIntegration = (props) => (
  <svg
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.415 1.759a.65.65 0 0 0-1.274-.256L8.585 14.24a.65.65 0 0 0 1.274.255L12.415 1.76ZM6.767 3.79a.65.65 0 0 1-.13.91L2.233 8l4.404 3.3a.65.65 0 0 1-.78 1.04L.76 8.52a.65.65 0 0 1 0-1.04l5.098-3.82a.65.65 0 0 1 .91.13Zm7.466 0a.65.65 0 0 1 .91-.13l5.097 3.82a.65.65 0 0 1 0 1.04l-5.098 3.82a.65.65 0 1 1-.779-1.04L18.767 8l-4.404-3.3a.65.65 0 0 1-.13-.91Z"
      fill={props.color}
    />
  </svg>
);
export default SvgIntegration;
